import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import ProtectedRoute from './ProtectedRoute';

// --- Public Page Imports ---
import HomePage from '../pages/HomePage';
import StudentLogin from '../pages/StudentLogin'; // Corrected path to be case-sensitive
import StaffLogin from '../pages/StaffLogin'; // Corrected path to be case-sensitive
// UPDATED: Correctly import the admin login page from its new location
import AdminLogin from '../pages/LoginPage';
import StudentEnquiry from '../pages/StudentEnquiry'; 

// --- Protected Route Module Imports ---
import AdminRoutes from './AdminRoutes';
import StudentRoutes from './StudentRoutes';
import StaffRoutes from './StaffRoutes';

export default function AppRoutes() {
  return (
    <Routes>
      {/* --- Public Routes --- */}
      <Route path="/" element={<HomePage />} />
      <Route path="/student-login" element={<StudentLogin />} />
      <Route path="/staff-login" element={<StaffLogin />} />
      {/* UPDATED: This route now renders the correct admin login component */}
      <Route path="/admin-login" element={<AdminLogin />} />
<Route path="/student-enquiry" element={<StudentEnquiry />} />

      {/* --- Protected Admin Routes --- */}
      <Route element={<ProtectedRoute userType="admin" />}>
        <Route path="/admin/*" element={<AdminRoutes />} />
      </Route>

      {/* --- Protected Student Routes --- */}
      <Route element={<ProtectedRoute userType="student" />}>
        <Route path="/student/*" element={<StudentRoutes />} />
      </Route>

      {/* --- Protected Staff Routes --- */}
      <Route element={<ProtectedRoute userType="staff" />}>
        <Route path="/staff/*" element={<StaffRoutes />} />
      </Route>

      {/* --- Catch-all Route --- */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};